<table class="table table-sm">
    <tbody>

    <tr>
        <td>
            <select class="form-control form-control-sm" [(ngModel)]="model.status" (change)="statusChange($event)">
                <option value="" disabled>Status</option>
                <option *ngFor="let s of isfStatus" value="{{s}}">{{s}}</option>
            </select>
        </td>
        <td>
            <input type="text" class="form-control form-control-sm" placeholder="BL" [(ngModel)]="filterData.bill" size="8"/>
        </td>
        <td>
            <input type="text" class="form-control form-control-sm" placeholder="Container" [(ngModel)]="filterData.container" size="8"/>
        </td>
        <td>
            <date-range (selected)="rangeChange($event)" [default]="filterData.dateRange" title="Created date range"></date-range>
        </td>
        <td>
            <button class="btn btn-sm btn-success w-100" (click)="search()"><i class="fa fa-search"></i> Search</button>
        </td>

        <td>
            <button class="btn btn-sm btn-danger w-100" (click)="clear()"><i class="fa fa-remove"></i> Clear</button>
        </td>

    </tr>

    </tbody>
</table>
